<template>
    <div class="alert alert-dismissible fade show alert-primary"
         v-if="show"
         id="vote-count-alert"
         role="alert"
    >
        <div class="row">
            <div class="col">
                <p>
                    <strong>Votes cast:</strong> {{ votesCast }}
                </p>

                <p><strong>Outstanding: </strong> {{ votesOutstanding }}</p>

            </div>

            <div class="col">
                <div class="d-grid gap-2 mb-2">
<!--                    NB, the modal will need to have been included on any page where this alert is used-->
                    <end-voting-button :motion="motion"></end-voting-button>
                    <end-voting-modal></end-voting-modal>
                </div>
                <div class="d-grid gap-2 mb-2">
                    <!--                    NB, moved the modal back to being included here because of problems when on different card-->
                    <abort-voting-button :motion="motion"></abort-voting-button>
                    <abort-voting-modal></abort-voting-modal>

                </div>
            </div>

        </div>


        <button type="button"
                class="btn-close"
                data-bs-dismiss="alert"
                aria-label="Close"
        >
            <span class="visually-hidden" aria-hidden="true">&times;</span>
        </button>
    </div>
</template>

<script>
import {isReadyToRock} from "../../../utilities/readiness.utilities";
import ChairMixin from "../../../mixins/chairMixin";
import MotionMixin from "../../../mixins/motionStoreMixin";
import EndVotingButton from "../../motions/end-voting-button";
import EndVotingModal from "../../motions/end-voting-modal";
import AbortVotingButton from "../../motions/abort-voting-button.vue";
import AbortVotingModal from "../../motions/abort-voting-modal.vue";

export default {
    name: "vote-count-alert",
    components: {AbortVotingModal, AbortVotingButton, EndVotingModal, EndVotingButton},
    props: [],

    mixins: [ChairMixin, MotionMixin],

    data: function () {
        return {}
    },


    computed: {
        // asyncComputed: {
        isVotingAllowed: function () {
            return isReadyToRock(this.motion) && this.motion.isVotingAllowed;
        },

        show: function () {
            return this.isChair && !this.isComplete && this.isVotingAllowed;
        },

        votesCast: function () {
            let cnt = this.$store.getters.getCastVotesCount;
            if (isReadyToRock(cnt)) return cnt;
            return '-';
        },

        votesOutstanding: function () {
            let cnt = this.$store.getters.getMemberCount;
            if (isReadyToRock(cnt)) return cnt;
            return '-';
        }

    },


    methods: {}

}
</script>

<style scoped>

</style>
